<div class="m-4" *transloco="let t">
  <form [formGroup]="ruleForm">
    <div class="form-group">
      <label for="pauseThreshold">{{ t("asin-inventory-rules-modal.pause_message", { asin: modalData.asin }) }}</label>
      <IInput
        type="number"
        id="pauseThreshold"
        name="pauseThreshold"
        [control]="pauseThreshold"
        [placeholder]="t('asin-inventory-rules-modal.threshhold_placeholder')"
      />
    </div>
    @if (pauseThreshold.invalid && (pauseThreshold.dirty || !pauseThreshold.untouched)) {
      @if (pauseThreshold.errors?.["min"]) {
        <div class="block">{{ t("asin-inventory-rules-modal.threshold_minimum") }}</div>
      }
      @if (pauseThreshold.errors?.["required"]) {
        <div class="block">{{ t("asin-inventory-rules-modal.threshold_mandatory") }}</div>
      }
      @if (pauseThreshold.errors?.["pattern"]) {
        <div class="block">{{ "Threshold should be an integer" }}</div>
      }
    }

    <div>
      <ICheckbox
        label="{{ t('asin-inventory-rules-modal.advertise_expected_checkbox') }}"
        [disabled]="ruleForm.controls['inbound'].disabled"
        [value]="ruleForm.controls['inbound'].value"
        (valueChange)="ruleForm.controls['inbound'].setValue($event)"
      />
    </div>
    <div class="mt-3">
      <ICheckbox
        label="{{ t('asin-inventory-rules-modal.never_pause_checkbox', { asin: modalData.asin }) }}"
        [disabled]="ruleForm.controls.noRule.disabled"
        [value]="ruleForm.controls['noRule'].value"
        (valueChange)="ruleForm.controls['noRule'].setValue($event)"
      />
    </div>

    <hr />

    <IButton
      type="button"
      [tooltipValue]="t('asin-inventory-rules-modal.apply_this_on_button', { asin: modalData.asin })"
      [label]="t('common.save')"
      [disabled]="ruleForm.invalid"
      (onClick)="save()"
    />

    @if (modalData.warningMessage && ruleForm.valid) {
      <div class="warning-message mb-4 mt-3">{{ modalData.warningMessage }}</div>
    }
  </form>
</div>
